import React, { useState, useEffect } from "react";
import './createpoll.css'
import {
    Form,
    Input,
    Button,
    DatePicker,
    message,
    Modal
  } from 'antd';
import { InfoCircleTwoTone, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Poll } from '../../../App';

interface CreatePollProps {
    requestUrl: string
    handleCancel: () => void
    refreshRequestBody: any

}

const CreatePoll: React.FC<CreatePollProps> = ({ requestUrl, handleCancel, refreshRequestBody }) => {
    const [newPoll, setNewPoll] = useState<Poll | undefined>(undefined)
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const navigate = useNavigate()

    const onFinish = (values: {
            question: string, 
            options: string[], 
            deadline: Date, 
            voter_emails: string[]  
        }) => {
        setLoading(true)
        setNewPoll({
            'question': values.question,
            'options': values.options,
            'deadline': values.deadline,
            'voter_emails': values.voter_emails
        }) 
    };


    useEffect(() => {

        const showModal = () => {
            setVisible(true);
        };

        const handleCancel = () => {
            window.location.reload()
        };

        if(newPoll) {
            const requestOptions = {
                method: 'POST',
                headers : {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${window.localStorage.getItem('access')}`
                },
                body: JSON.stringify(newPoll)
            }
    
            fetch(`${requestUrl}/polling/polls/`, requestOptions)
                .then(response => {
                    console.log(response.status)
                    switch (response.status) {
                        case 201:
                            showModal()
                            setTimeout(handleCancel, 2000)
                            break;
                        case 400:
                            message.error('There is a problem with the inputs.')
                            setLoading(false)
                            break;
                        case 401:
                            const refreshToken = fetch(`${requestUrl}/auth/token/refresh/`, refreshRequestBody)
                                .then(response => {
                                    if(response.status === 200){
                                        return response.json()
                                    } else {
                                        message.warning('Session expired')
                                        navigate('/login')
                                    }
                                })
                                const createPoll = async () => {
                                    const newAccessToken = await refreshToken
                                    if(newAccessToken) {
                                        window.localStorage.setItem('access', newAccessToken.access)
    
                                        const newRequestOptions =  {
                                            method: 'POST',
                                            headers : {
                                                'Content-Type': 'application/json',
                                                'Authorization': `Bearer ${newAccessToken.access}`
                                            },
                                            body: JSON.stringify(newPoll)
                                        }
            
                                        fetch(`${requestUrl}/polling/polls/`, newRequestOptions)
                                        .then(response => {
                                            switch (response.status) {
                                                case 201:
                                                    showModal()
                                                    setTimeout(handleCancel, 2000)
                                                    break;
                                                case 400:
                                                    message.error('There is a problem with the inputs.')
                                                    setLoading(false)
                                                    break;
                                            }
                                        })
                                    }
                                }
                                createPoll()
                    }
                    })
                .catch(error => console.log('error', error));
            ;
        }
    }, [newPoll, navigate, refreshRequestBody, requestUrl])
    
    
    return(
        <Form
        wrapperCol={{span: 24}}
        layout="horizontal"
        onFinish={onFinish}
        name="poll"
        >
            <div className='create_poll_titles'>Questionare Information</div>
            <Form.Item name="question">
                <Input placeholder='Question'/>
            </Form.Item>

            <Form.List 
                name="options"
                rules={[
                    {
                        validator: async (_, names) => {
                        if (!names || names.length < 2) {
                            return Promise.reject(new Error('At least 2 options'));
                        }
                        },
                    },
                    ]}
            >       
                {(options, { add, remove }, { errors }) => (
                <>
                    {options.map((option) => (
                        <Form.Item
                            key={option.key}
                            noStyle  
                            >
                            <Form.Item
                                {...option}
                                validateTrigger={['onChange', 'onBlur']}
                                style={{marginBottom: '1rem'}}
                                >
                                <div style={{display: 'flex'}}>
                                    <div style={{flexGrow: 1, marginRight: '0.5rem'}}>
                                        <Input placeholder="Option"/>
                                    </div>
                                    <div style={{alignSelf: 'center'}}>
                                        <MinusCircleOutlined
                                            onClick={() => remove(option.name)}
                                        />
                                    </div>
                                </div>
                            </Form.Item>
                        </Form.Item>
                    ))}

                    <Form.Item>
                        <Button
                            type="dashed"
                            onClick={() => add()}
                            style={{ width: '100%' }}
                            icon={<PlusOutlined />}
                        >
                            Add Option
                        </Button>
                        <Form.ErrorList errors={errors} />
                    </Form.Item>
                </>
                )}
            </Form.List>

            <Form.Item name="deadline">
                <DatePicker 
                    showTime={{ format: 'HH:mm' }} 
                />
            </Form.Item>

            <div className='create_poll_titles'>Voter Information</div>

            <Form.List 
                name="voter_emails"
                rules={[
                    {
                        validator: async (_, names) => {
                        if (!names || names.length < 2) {
                            return Promise.reject(new Error('At least 2 options'));
                        }
                        },
                    },
                    ]}
            >
                {(voter_emails, { add, remove }, { errors }) => (
                <>
                    {voter_emails.map((voter_email) => (
                        <Form.Item
                            key={voter_email.key}
                            noStyle  
                        >
                            <Form.Item
                                {...voter_email}
                                validateTrigger={['onChange', 'onBlur']}
                                style={{marginBottom: '1rem'}}
                                >
                                <div style={{display: 'flex'}}>
                                    <div style={{flexGrow: 1, marginRight: '0.5rem'}}>
                                        <Input placeholder="E-mail"/>
                                    </div>
                                    <div style={{alignSelf: 'center'}}>
                                        <MinusCircleOutlined
                                            onClick={() => remove(voter_email.name)}
                                        />
                                    </div>
                                </div>
                            </Form.Item>
                        </Form.Item>
                    ))}

                    <Form.Item>
                        <Button
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                        >
                            Add Voter
                        </Button>
                        <Form.ErrorList errors={errors} />
                    </Form.Item>
                </>
                )}
            </Form.List>

            <Form.Item id='button_wrapper'>
                <Button block type="primary" htmlType="submit" loading={loading}>Create Poll</Button>
                <Modal visible={visible} closable={false} footer={null}>
                    <p style={{fontSize: '1.3rem', margin:0}} ><InfoCircleTwoTone /> Poll has been created.</p>
                </Modal>
            </Form.Item>
        </Form>                          
    )
};


export default CreatePoll;